import React, { FC } from "react";

interface WhiteTitleCardProps {
  cardTitle?: string;
  children: React.ReactNode;
}

const WhiteTitledCard: FC<WhiteTitleCardProps> = ({ cardTitle, children }) => {
  return (
    <div className="flex h-auto w-full flex-col gap-6 rounded-3xl bg-white p-4 sm:p-6">
      {cardTitle ? (
        <h4 className="text-lg font-bold capitalize">{cardTitle}</h4>
      ) : null}
      <div className="w-full">{children}</div>
    </div>
  );
};

export default WhiteTitledCard;
